function scorecard_list_autofill(data)
{
	$( document ).ready(function() {
		if(typeof data != 'undefined')
		{
			var options = {
				'data':data,
				'getValue':'company',
				'dataType': "json",
				'list': {
					'match': {
						'enabled': true
					},
					'maxNumberOfElements': 10,
					onChooseEvent: function() {
						var selectedItemValue = $("#ss_company_name_search").getSelectedItemData().url;
						window.location = selectedItemValue
					},
					onHideListEvent: function() {

					}
				},
				'template': {
					'type':'custom',
					'method': function (value, item) {
						return '<a class="s-1" href="'+item.url+'">' + value + '</a>'
					}
				}
			}
			$('#ss_company_name_search').easyAutocomplete(options);
		}
	});

	$( document ).ready(function() {
		if(typeof data != 'undefined')
		{
			var options = {
				'data':data,
				'getValue':'company',
				'dataType': "json",
				'list': {
					'match': {
						'enabled': true
					},
					'maxNumberOfElements': 10,
					onChooseEvent: function() {
						var selectedItemTicker = $("#compare_search_field").getSelectedItemData().ticker;
						add_company_to_compare(selectedItemTicker)
						return false
					},
					onHideListEvent: function() {

					}
				},
				'template': {
					'type':'custom',
					'method': function (value, item) {
						return '<span class="s-1">' + value + '</span>'
					}
				}
			}
			$('#compare_search_field').easyAutocomplete(options);
		}
	});
}

$( document ).ready(function() {
	hightlight_sort_column()
	$('#sl_filter_industry').on('change', function () {
		var industry_to_filter = $("#sl_filter_industry").val();
		if(industry_to_filter!="")
		{
			$(".scorecard_list tr").each(function(){
				var current_industry = $(this).find(".industry_name").text();
				if(current_industry!=industry_to_filter)
				{
					$(this).hide()
				}
				else
				{
					$(this).show()
				}
			})
			var selected_topic = $("#sl_filter_topics").val();
			if(selected_topic!="")
			{
				sort_scorecard_list(true,".overall_score");
				sort_topic_score(true);
			}
		}
		else
		{
			$(".scorecard_list tr").each(function(){
				$(this).show()
			})
		}
		
	});

	$('#sl_filter_topics').on('change', function () {
		var selected_topic = $("#sl_filter_topics").val();
		if(selected_topic!="")
		{
			sort_scorecard_list(true,".overall_score");
			sort_topic_score(true);
		}
		else
		{
			$(".scorecard_list tr").each(function(){
				$(this).show()
			})
		}
		
	});
});

var current_sort_column = 'overall_sort';

function hightlight_sort_column(){
	$(".company_sort a").removeClass("active")
	$(".overall_sort a").removeClass("active")
	$(".topic_sort a").removeClass("active")
	if(current_sort_column=='company_sort')
	{
		$(".company_sort a").addClass("active")
	}
	else if(current_sort_column=='overall_sort')
	{
		$(".overall_sort a").addClass("active")
	}
	else if(current_sort_column=='topic_sort')
	{
		$(".topic_sort a").addClass("active")
	}
}

function sort_company_name()
{
	$("#sl_filter_topics").val("")
	current_sort_column = 'company_sort';
	hightlight_sort_column()
	var is_asc = $(".company_sort i").attr('class').indexOf("-down")>-1?false:true;
	$(".company_sort i").removeClass("fa-angle-"+(is_asc?"up":"down"));
	$(".company_sort i").addClass("fa-angle-"+(is_asc?"down":"up"));
	sort_scorecard_list(!is_asc,".company_name");
}

function sort_overall_score()
{
	$("#sl_filter_topics").val("")
	current_sort_column = 'overall_sort';
	hightlight_sort_column()
	var is_asc = $(".overall_sort i").attr('class').indexOf("-down")>-1?false:true;
	$(".overall_sort i").removeClass("fa-angle-"+(is_asc?"up":"down"));
	$(".overall_sort i").addClass("fa-angle-"+(is_asc?"down":"up"));
	sort_scorecard_list(!is_asc,".overall_score");
}

function sort_topic_score(force_desc)
{
	var selected_topic = $("#sl_filter_topics").val().toLowerCase()
	if(selected_topic!='')
	{
		current_sort_column = 'topic_sort';
		hightlight_sort_column()
		sort_scorecard_list(true,".overall_score");
		var is_asc = $(".topic_sort i").attr('class').indexOf("-down")>-1?false:true;
		$(".topic_sort i").removeClass("fa-angle-"+(is_asc?"up":"down"));
		if(force_desc)
		{
			is_asc=force_desc
		}
		$(".topic_sort i").addClass("fa-angle-"+(is_asc?"down":"up"));
		sort_scorecard_list(!is_asc,"."+selected_topic+" .topic_score")
	}
	else
	{
		alert("Please select a topic before sorting!")
		return false
	}
}

function sort_scorecard_list(is_asc, selector)
{
	var table = $(".scorecard_list")
	var rows = $(".scorecard_list tr").toArray().sort(scorecard_comparer(selector))
	if (!is_asc)
	{
		rows = rows.reverse();
	}
	for (var i = 0; i < rows.length; i++)
	{
		table.append(rows[i]);
	}
}

function scorecard_comparer(selector)
{
	return function(a, b)
	{
		var valA = $(a).find(selector).text()
		var valB = $(b).find(selector).text()
		return $.isNumeric(valA) && $.isNumeric(valB) ? valA - valB : valA.toString().localeCompare(valB)
    }
}

function add_company_to_compare(ticker)
{
	var current_companies = $('.company_compare_panel .company_badge').map(function(i, e) {return $(e).attr('data-ticker')}).toArray();
	if(current_companies.length<=2)
	{
		$(".company_compare_panel .company_list").append($(".company_badge[data-ticker='"+ticker+"']").clone())
		$(".company_compare_panel .company_badge[data-ticker='"+ticker+"']").prepend('<i class="fa fa-times" onclick="$(this).parent().remove()"></i>')
	}
	else
	{
		alert("You can compare only 3 companies at a time.")
		return false
	}
}

function compare_companies(url_prefix)
{
	var current_companies = $('.company_compare_panel .company_badge').map(function(i, e) {return $(e).attr('data-ticker')}).toArray();
	if(current_companies.length>0)
	{
		window.location=url_prefix+'?co='+current_companies.join();
	}
}

